/* eslint-disable jsx-a11y/anchor-has-content, jsx-a11y/heading-has-content */
// node modules
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import NoSsr from '@material-ui/core/NoSsr';

// app modules: actions
import getCollections from 'actions/user/getCollections';

// app modules: components
import { CollectionsMatrix } from 'components/Matrix';
import Button from 'components/Button';
import Icon from 'components/Icon';
import { CollectionItemComponent } from 'components/SearchResultsItem';
import LoggedInWithCollections from 'components/MyCollections/LoggedInWithCollections';

// app modules: props
import CollectionsProps from 'components/Collection/CollectionsProps';
import LoginProps from 'components/Login/LoginProps';

// assets
import { COLOURS } from '../../constants';
import CssMyCollections from './MyCollections.scss';

class MyCollections extends React.Component {
  static propTypes = {
    collections: CollectionsProps.collections.isRequired,
    user: LoginProps.isRequired,
    getCollections: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { user } = this.props;
    if (user && user.id) {
      this.props.getCollections(user.id);
    }
  }

  introForNotLoggedInUser() {
    const { t } = this.props;
    return (
      <div className="my-collections__empty--headline  margin-bottom-10">
        <p>
          To create personal collections of your {t('favorite')} recipes,{' '}
          <a className="link link--energized" href="#signup">
            sign up
          </a>{' '}
          for free membership of ckbk.
        </p>
      </div>
    );
  }

  renderEmpty() {
    const { collections, user, t } = this.props;

    if (collections.length === 0) {
      return (
        <div className="my-collections__empty margin-top-40 margin-bottom-40">
          {user.logged_in ? (
            <p className="my-collections__empty--headline">
              Create personal collections to bring together your {t('favorite')} recipes, authors
              and cookbooks.
            </p>
          ) : (
            this.introForNotLoggedInUser()
          )}
          <p className="my-collections__paragraph margin-bottom-40">
            You can use collections to plan a meal, or to gather ideas relating to specific
            ingredients, dishes or cuisines: &quot;brunch dishes&quot;, &quot;summer lunches&quot;,
            &quot;weeknight stir fries&quot;, &quot;sweetcorn recipes&quot;, or &quot;Southeast
            Asian cookbooks&quot;.
          </p>
          <p className="my-collections__paragraph">
            To add items to a collection, use
            <Button
              className="my-collections__button"
              themeType="clear"
              themeName="energized"
              size="large"
              title="Add to collection"
            >
              <Icon fill={COLOURS.ENERGIZED} name="list-add" height="20" width="20" mr={5} />
              Add to collection
            </Button>
          </p>
          <p className="my-collections__paragraph">
            You can also use the
            <Button
              className="my-collections__button"
              themeType="clear"
              themeName="energized"
              size="large"
              title="Add to collection"
            >
              <Icon fill={COLOURS.ENERGIZED} name="dots" height="20" width="20" />
            </Button>
            menu on search results
          </p>
        </div>
      );
    }

    return null;
  }

  render() {
    const { user, collections } = this.props;

    const itemProps = { mobileViewAsList: true };
    let favouriteLink = null;
    if (user && user.logged_in) {
      favouriteLink = <CollectionItemComponent.FavouriteCollection {...itemProps} />;
    }

    return (
      <NoSsr>
        {user && user.logged_in && collections.length ? (
          <LoggedInWithCollections favouriteLink={favouriteLink} itemProps={itemProps} />
        ) : (
          <>
            {this.renderEmpty()}
            <CollectionsMatrix
              withAddOption
              prefixItems={[favouriteLink]}
              items={[]}
              showAll
              itemProps={itemProps}
            />
          </>
        )}
      </NoSsr>
    );
  }
}

const mapStateToProps = state => ({
  collections: Object.values(state.user.collections),
  user: state.user,
});

const mapDispatchToProps = {
  getCollections,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(withStyles(CssMyCollections)(MyCollections)));
